var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWellItSpaceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 23,
    viewBox: "0 0 17 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.35714 22H10.6429M4.21429 14.65H12.7857M1 8.35C1 6.40066 1.79018 4.53116 3.1967 3.15276C4.60322 1.77437 6.51088 1 8.5 1C10.4891 1 12.3968 1.77437 13.8033 3.15276C15.2098 4.53116 16 6.40066 16 8.35C16.0007 9.53343 15.7086 10.6994 15.1488 11.748C14.589 12.7965 13.7782 13.6965 12.7857 14.3707L12.205 17.065C12.1281 17.5616 11.8721 18.0148 11.4835 18.3423C11.0949 18.6698 10.5993 18.8499 10.0868 18.85H6.91321C6.40066 18.8499 5.90512 18.6698 5.51649 18.3423C5.12786 18.0148 4.87188 17.5616 4.795 17.065L4.21429 14.3822C3.22151 13.7057 2.41061 12.8036 1.85088 11.7531C1.29114 10.7027 0.999203 9.53505 1 8.35V8.35Z",
    stroke: "#060606",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellItSpaceIcon);
export default __webpack_public_path__ + "static/media/well-it-space--icon.8e5ace212286c86039995b0146243e6b.svg";
export { ForwardRef as ReactComponent };